import React from 'react';
import PropTypes from 'prop-types';

import FluidImg from 'Components/Utility/FluidImg';
import imageSizes from 'Components/Cards/image-sizes';

export default function BundleProductCardCover({
  lazy,
  cover,
  name,
  type,
  displayType,
  coverType,
  sizesOverride,
}) {
  let coverSize = 'standard';
  if (type !== 'game' && type !== 'dlc' && type !== 'bundle') {
    coverSize = 'portrait';
  }
  if (displayType !== 'game' && displayType !== 'dlc') {
    coverSize = 'portrait';
  }
  if (coverType === '16x9') {
    coverSize = 'standard';
  }
  if (coverType === 'portrait') {
    coverSize = 'portrait';
  }
  if (coverType === 'square') {
    coverSize = 'square';
  }
  if (coverType === 'landscape') {
    coverSize = 'landscape';
  }

  if (coverSize === 'portrait' || coverSize === 'landscape') {
    return (
      <React.Fragment>
        <FluidImg
          lazy={lazy}
          className="img-force-full cover-background"
          src={cover}
          alt={name}
          sizesOverride={sizesOverride}
        />
        <FluidImg
          lazy={lazy}
          className="img-force-full cover-foreground"
          src={cover}
          alt={name}
          sizesOverride={sizesOverride}
        />
      </React.Fragment>
    );
  }

  if (coverSize === 'square') {
    return (
      <div className="responsive-image-island">
        <div className="responsive-image responsive-image--1by1">
          <FluidImg
            lazy={lazy}
            className="img-force-full"
            sizesOverride={sizesOverride}
            src={cover}
            alt={name}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="responsive-image-island">
      <div className="responsive-image responsive-image--16by9">
        <FluidImg
          ratio16by9
          lazy={lazy}
          className="img-force-full"
          sizesOverride={sizesOverride}
          src={cover}
          alt={name}
        />
      </div>
    </div>
  );
}

BundleProductCardCover.propTypes = {
  cover: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  displayType: PropTypes.string,
  coverType: PropTypes.string,
  sizesOverride: PropTypes.string,
  lazy: PropTypes.bool,
};

BundleProductCardCover.defaultProps = {
  cover: '',
  name: '',
  type: 'game',
  displayType: 'game',
  coverType: '',
  sizesOverride: imageSizes(3, 4, 6, 6),
  lazy: false,
};
